export default __webpack_public_path__ + "images/jalisco-logo-rombo.797071e9741c862eb6b8c71b79e83ed9.png";